import { Box } from "@mantine/core";

interface IframeProps {
  allow?: string;
  height?: number;
  src?: string;
  title?: string;
}

/**
 * Iframe renders the {% iframe %} tag as a lazily-loaded, rounded embedded
 * frame. It is server-rendering safe: the markup is static and the browser
 * defers loading until the frame nears the viewport.
 */
export const Iframe = ({ allow, height = 480, src, title }: IframeProps) => (
  // mantine:exempt — full border + radius on the embedded frame; Mantine has no border shortcut prop.
  <Box
    allow={allow}
    component="iframe"
    height={height}
    loading="lazy"
    my="md"
    src={src}
    style={{
      border: "1px solid var(--mantine-color-default-border)",
      borderRadius: "var(--mantine-radius-md)",
      width: "100%",
    }}
    title={title}
  />
);
